import './style.scss';

import React from 'react';
import { connect } from 'react-redux';
import { trackNow } from 'shared/models/analytic';
import { trackInfo, defaultIngredientOption } from 'shared/models/product';
import { getProduct } from 'shared/models/api';
import * as cartActions from 'components/cart/actions';
import BaseProductItem from './base';
import Button from 'components/ui/button';
import View from 'components/ui/view';

class ProductItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = { cartHasOpened: false };
    this.track = this.track.bind(this);
    this.add = this.add.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.cartOpen && !prevProps.cartOpen)
      this.setState({ cartHasOpened: true });
  }

  track() {
    trackNow('Product Clicked', trackInfo(this.props));
  }

  add(e) {
    e.preventDefault();
    if (this.props.recipe) {
      this.addCollection();
    } else {
      this.props.addCart(this.props, 1, { checkout: this.props.checkout });
      setTimeout(this.props.showCart, 500);
    }
  }

  addCollection() {
    getProduct(this.props.sku_id).then(product => {
      const ingredients = product.ingredients || [];
      if (ingredients.length) {
        const defaultProducts = ingredients
          .map(defaultIngredientOption)
          .filter(p => !!p.price);
        if (defaultProducts.length) {
          this.props.addSeveral(defaultProducts, 1, {
            checkout: this.props.checkout
          });
        }
      } else {
        this.props.addCart(this.props, 1, { checkout: this.props.checkout });
      }
      setTimeout(this.props.showCart, 500);
    });
  }

  render() {
    let price = this.props.price;
    if (!this.props.address || this.props.soldout) price = 0;
    const className =
      (this.props.className || 'col-xs-3 col-sm-4 col-md-4 col-lg-4 section') +
      ' product-item';
    const url = this.props.url;
    const linkProps = {
      to: url && url.indexOf('/') === 0 ? url : '/' + url,
      onClick: this.track,
      itemProp: 'url'
    };

    return (
      <div className={className} itemScope itemType="http://schema.org/Product">
        <div className="product-item-container">
          <BaseProductItem
            product={{ ...this.props }}
            includeItemProps
            lazyLoad={!this.state.cartHasOpened}
            linkProps={linkProps}
            renderOnHover={
              !price
                ? null
                : () => (
                    <View padding="sm">
                      <Button
                        primary
                        fullWidth
                        raised
                        round
                        margin="none"
                        onClick={this.add}
                      >
                        Add
                      </Button>
                    </View>
                  )
            }
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    address: state.address.lat ? state.address : null,
    cartOpen: state.cart.show
  };
}

export default connect(
  mapStateToProps,
  { ...cartActions }
)(ProductItem);
